 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"patch-notes-ca":"patch-notes-ca","patch-notes-de":"patch-notes-de","patch-notes-en":"patch-notes-en","patch-notes-fr":"patch-notes-fr"}[chunkId]||chunkId) + ".v.7.0.0.1748939106438.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-02786f94":1,"chunk-02c34e8d":1,"chunk-352edc45":1,"chunk-110fe032":1,"chunk-1388ca54":1,"chunk-18d6cf7e":1,"chunk-1fe6cf32":1,"chunk-20fa05fb":1,"chunk-244abd65":1,"chunk-2e519f92":1,"chunk-435f4ceb":1,"chunk-45307d54":1,"chunk-6bee6494":1,"chunk-4bff95b4":1,"chunk-37df892e":1,"chunk-16999c59":1,"chunk-a9aad478":1,"chunk-66b8917e":1,"chunk-c72cb67e":1,"chunk-47637f4c":1,"chunk-4dcdf90c":1,"chunk-4e0775d2":1,"chunk-4f929a8d":1,"chunk-54a3c077":1,"chunk-5ff3baf5":1,"chunk-60349d8a":1,"chunk-6115470e":1,"chunk-6a52854a":1,"chunk-70a15919":1,"chunk-720d825e":1,"chunk-16edd3b0":1,"chunk-35022f30":1,"chunk-7e0049d6":1,"chunk-20605758":1,"chunk-71538e21":1,"chunk-7ed35a62":1,"chunk-aad2c0c6":1,"chunk-af73c3d6":1,"chunk-c31d6620":1,"chunk-c45afbac":1,"chunk-cd394644":1,"chunk-dc2de64a":1,"chunk-dffd7196":1,"chunk-e1ac29dc":1,"chunk-fbf76646":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"patch-notes-ca":"patch-notes-ca","patch-notes-de":"patch-notes-de","patch-notes-en":"patch-notes-en","patch-notes-fr":"patch-notes-fr"}[chunkId]||chunkId) + "." + {"chunk-02786f94":"93ecd0eb","chunk-02c34e8d":"8f66f57b","chunk-352edc45":"8c76afff","chunk-047ad542":"31d6cfe0","chunk-110fe032":"7c0edf40","chunk-1388ca54":"ed794041","chunk-18d6cf7e":"dce3372a","chunk-1fe6cf32":"1e6e68d9","chunk-20fa05fb":"b38369be","chunk-244abd65":"998f59bb","chunk-2b50b0d5":"31d6cfe0","chunk-2d0afa4b":"31d6cfe0","chunk-2d0baa6b":"31d6cfe0","chunk-2d221bba":"31d6cfe0","chunk-2e285d75":"31d6cfe0","chunk-2e519f92":"b09478e6","chunk-435f4ceb":"603687fe","chunk-45307d54":"1781e5a5","chunk-6bee6494":"5aa469e2","chunk-4bff95b4":"2ee50219","chunk-2d2307fb":"31d6cfe0","chunk-37df892e":"fbf9e080","chunk-16999c59":"9da447d8","chunk-a9aad478":"2ee50219","chunk-66b8917e":"e8a0fb84","chunk-281cca88":"31d6cfe0","chunk-4332fe40":"31d6cfe0","chunk-afc207ec":"31d6cfe0","chunk-00834553":"31d6cfe0","chunk-01781b11":"31d6cfe0","chunk-0a2168e2":"31d6cfe0","chunk-11b58a48":"31d6cfe0","chunk-12e67bd7":"31d6cfe0","chunk-14bd39c2":"31d6cfe0","chunk-0a004d54":"31d6cfe0","chunk-17d66736":"31d6cfe0","chunk-18a42968":"31d6cfe0","chunk-20ab1e94":"31d6cfe0","chunk-26ddb0ac":"31d6cfe0","chunk-32dd2d20":"31d6cfe0","chunk-344c5469":"31d6cfe0","chunk-36be1906":"31d6cfe0","chunk-3b259096":"31d6cfe0","chunk-428cf8b7":"31d6cfe0","chunk-462a25e8":"31d6cfe0","chunk-501c0090":"31d6cfe0","chunk-61ea4b33":"31d6cfe0","chunk-71a237a2":"31d6cfe0","chunk-78c293af":"31d6cfe0","chunk-8666e056":"31d6cfe0","chunk-af49ab64":"31d6cfe0","chunk-ba70f880":"31d6cfe0","chunk-e2317336":"31d6cfe0","chunk-eb15033e":"31d6cfe0","chunk-f96c06b4":"31d6cfe0","chunk-1b7e7d52":"31d6cfe0","chunk-1e2885c0":"31d6cfe0","chunk-28071a20":"31d6cfe0","chunk-2c843c4c":"31d6cfe0","chunk-349dbde1":"31d6cfe0","chunk-37b9a379":"31d6cfe0","chunk-3db4ce3a":"31d6cfe0","chunk-3fb1bbda":"31d6cfe0","chunk-3fc6b44c":"31d6cfe0","chunk-40eb34d6":"31d6cfe0","chunk-4411e3a2":"31d6cfe0","chunk-536b210e":"31d6cfe0","chunk-56ba208f":"31d6cfe0","chunk-582d832b":"31d6cfe0","chunk-59947223":"31d6cfe0","chunk-5aedb963":"31d6cfe0","chunk-5ca515cb":"31d6cfe0","chunk-6307796f":"31d6cfe0","chunk-6428cec4":"31d6cfe0","chunk-6c02957c":"31d6cfe0","chunk-6f67c034":"31d6cfe0","chunk-770a7ece":"31d6cfe0","chunk-77ba46a6":"31d6cfe0","chunk-7b320d2c":"31d6cfe0","chunk-7b7fa326":"31d6cfe0","chunk-82af3b1c":"31d6cfe0","chunk-88419ca6":"31d6cfe0","chunk-8cf7e92a":"31d6cfe0","chunk-ab2365b8":"31d6cfe0","chunk-be775882":"31d6cfe0","chunk-c72cb67e":"ca673d2a","chunk-c8c0761c":"31d6cfe0","chunk-ca259672":"31d6cfe0","chunk-d80ab508":"31d6cfe0","chunk-149942c8":"31d6cfe0","chunk-2d0aacba":"31d6cfe0","chunk-f17bca68":"31d6cfe0","chunk-fda4eb26":"31d6cfe0","chunk-47637f4c":"5574b8fd","chunk-4dcdf90c":"d9cacbee","chunk-4e0775d2":"3948d18f","chunk-4f929a8d":"571a2712","chunk-54a3c077":"d67ef232","chunk-5ff3baf5":"44ebefe9","chunk-60349d8a":"73f5d4ef","chunk-6115470e":"999648f2","chunk-6a52854a":"dea7e2ad","chunk-70a15919":"2b92e184","chunk-7110de74":"31d6cfe0","chunk-720d825e":"8c24ed96","chunk-75f0a832":"31d6cfe0","chunk-16edd3b0":"3bcb4467","chunk-35022f30":"19fd613d","chunk-7d579b14":"31d6cfe0","chunk-20d7fec3":"31d6cfe0","chunk-ddce5642":"31d6cfe0","chunk-7e0049d6":"9be74642","chunk-20605758":"bfd96d0c","chunk-71538e21":"2178157c","chunk-7ed35a62":"e5d47be9","chunk-8e94467a":"31d6cfe0","chunk-aad2c0c6":"d27e13bd","chunk-af73c3d6":"0cf23f3e","chunk-c31d6620":"06395d80","chunk-c45afbac":"486339f3","chunk-cd394644":"c139a662","chunk-cf9b4218":"31d6cfe0","chunk-dc2de64a":"fd21e502","chunk-dffd7196":"2ec8bc64","chunk-e1ac29dc":"4838ac82","chunk-fbf76646":"5b63c44e","patch-notes-ca":"31d6cfe0","patch-notes-de":"31d6cfe0","patch-notes-en":"31d6cfe0","patch-notes-fr":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
